import {
    fetchFaxDataByOrderId,
    sendOrdersViaEmailApi
} from "@/api/fax-email";

const faxEmail = {
    namespaced: true,
    state: () => ({
        faxArr: []
    }),
    getters: {
        getFaxData: (state) => {
            return state.faxArr
        }
    },
    actions: {
        getFaxDataByOrderId({ commit }, payload) {
            return new Promise((resolve, reject) => {
                fetchFaxDataByOrderId(payload)
                    .then((result) => {
                        commit('SET_FAX_DETAILS', result)
                    })
                    .catch(() => {
                        console.log("error from getFaxDataByOrderId store")
                    })
            })
        },

        sendOrdersViaEmail({ commit }, payload) {
            return new Promise((resolve, reject) => {
                sendOrdersViaEmailApi(payload)
                    .then((result) => {
                        if (result.status === 200) {
                            resolve()
                        }
                    })
                    .catch(() => {
                        console.log("error from sendOrdersViaEmail store")
                    })
            })
        }
    },
    mutations: {
        SET_FAX_DETAILS: (state, data) => {
            state.faxArr = data.length > 0 ? data : []
        }
    },
};

export default faxEmail;
